import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export function useStartChat() {
  const { user } = useAuth();
  const navigate = useNavigate();
  return async (expert) => {
    if (!user) { navigate("/connexion"); return; }
    if (user.role !== "consultant") { toast.error("Seuls les consultants peuvent démarrer une consultation."); return; }
    try {
      const { data } = await api.startConsultation(expert.id);
      navigate(`/chat/${data.id}`);
    } catch (e) {
      const code = e.response?.status;
      if (code === 402) { toast.error("Solde insuffisant. Rechargez vos crédits."); navigate("/credits"); }
      else toast.error(formatApiError(e.response?.data?.detail));
    }
  };
}
